import { api } from './api';

/**
 * Stakeholder views: plain-language "what's shipping" lenses for non-eng teams.
 * The shared axios instance attaches the bearer token, so only the public status
 * call is expected to work without a login.
 */

/**
 * Every stakeholder view an organization has configured.
 * @param {string} organizationId
 */
export const listStakeholderViews = async (organizationId) => {
  const res = await api.get('/stakeholder-views', { params: { organizationId } });
  return res.data;
};

/**
 * Create a view.
 * @param {Object} payload - { organizationId, name, description, filters, isPublic }
 */
export const createStakeholderView = async (payload) => {
  const res = await api.post('/stakeholder-views', payload);
  return res.data;
};

/**
 * Update a view.
 * @param {string} viewId
 * @param {Object} updates - { name, description, filters, isPublic }
 */
export const updateStakeholderView = async (viewId, updates) => {
  const res = await api.put(`/stakeholder-views/${viewId}`, updates);
  return res.data;
};

/**
 * Delete a view.
 * @param {string} viewId
 */
export const deleteStakeholderView = async (viewId) => {
  const res = await api.delete(`/stakeholder-views/${viewId}`);
  return res.data;
};

/**
 * Mint a fresh public token, killing any leaked link.
 * @param {string} viewId
 */
export const rotateStakeholderToken = async (viewId) => {
  const res = await api.post(`/stakeholder-views/${viewId}/rotate-token`);
  return res.data;
};

/**
 * The plain-language bets a logged-in member (viewer included) sees for a view.
 * @param {string} viewId
 * @returns {Promise<{ view: { name, description }, bets: Array }>}
 */
export const getStakeholderBets = async (viewId) => {
  const res = await api.get(`/stakeholder-views/${viewId}/bets`);
  return res.data;
};

/**
 * The public status page payload, resolved from an opaque token with no login.
 * @param {string} token
 * @returns {Promise<{ view: { name, description }, bets: Array }>}
 */
export const getPublicStatus = async (token) => {
  const res = await api.get(`/public/status/${token}`);
  return res.data;
};

const stakeholderApi = {
  listStakeholderViews,
  createStakeholderView,
  updateStakeholderView,
  deleteStakeholderView,
  rotateStakeholderToken,
  getStakeholderBets,
  getPublicStatus,
};

export default stakeholderApi;
